<template>
    <!--
          作者：kmdshop
          时间：2020-06-20
          描述：diy组件-参数设置-菜单组
      -->
    <div>
      <div class="common-form"><span>{{ curItem.name }}</span></div>
      <el-form size="small" :model="curItem" label-width="100px">
        <el-form-item label="地图：">
  
        </el-form-item>
      </el-form>
      <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
    </div>
  </template>
  
  <script>
      import Setlink from '@/components/setlink/Setlink';
    export default {
        components: {
            Setlink,
        },
      data() {
        return {
          /*是否选择链接*/
            is_linkset: false,
            index: null,
        };
      },
      props: ['curItem', 'selectedIndex', 'opts'],
      methods: {
  
        /*选择链接*/
          changeLink(index) {
              this.is_linkset = true;
              this.index = index;
          },
  
        /*获取链接并关闭弹窗*/
          closeLinkset(e) {
            this.is_linkset = false;
            if (e) {
              this.curItem.data[this.index].linkUrl=e.url;
              // this.curItem.data[this.index].name = e.name;
              this.curItem.data[this.index].name = '链接到' + ' ' + e.type + ' ' + e.name;
              if(e.appid){
                this.curItem.data[this.index].appid = e.appid;
              }
            }
          },
      }
    };
  </script>
  
  <style>
  
  </style>
  


// WEBPACK FOOTER //
// src/views/page/page/diy/params/Map.vue